import {isEmpty, cloneDeep, uniq} from 'lodash'
import SelectDropdown from '@/components/component/Reuse/SelectDropdown/SelectDropdown.vue'
import {getReportingGroups, getMetaCollectionList, getMetaDossierList, shortServiceBulkUpload, isUrlReachable} from '@/libs/api/api'
import InfiniteLoading from 'vue-infinite-loading';
import constants from '@/libs/constant/constants';
// import bulkUpload from '@/mixins/bulkuploadShortUrlService'
import { message, urlValidation, loader } from '@/libs/helper';

export default {
    name: 'BulkUpdate',
    components: { 
        SelectDropdown,
        InfiniteLoading
    },
    // mixins: [bulkUpload],
    props: {
        markedTableItems: {
            type: Array,
            default: () => {}
        },
        tableData: {
            type: Array,
            default: () => {}
        },
        getLocationRouteName: {
            type: Function,
            default: () => {}
        }
    },
    created() {
        this.EXTERNAL = 'EXTERNAL'
        this.INTERNAL = 'INTERNAL'
        this.NO = 'NO'
        this.YES = 'YES'
        this.baseUrl = process.env.VUE_APP_ENV === 'production' ? 'accura.onl' : process.env.VUE_APP_ENV === 'staging' ? 'web-staging.accura.onl' : 'web-dev.accura.onl'
    },
    beforeMount() {
        
    },
    computed: {
        table () {
            return this.tableData.filter(item => {
                if (new Set(this.markedTableItems).has(item._id)) return true
            })
        }
    },
    mounted() {
        this.details = JSON.parse(localStorage.getItem('details'))
        this.fetchreportingGroups()
        this.fetchCollections(true)
        this.fetchDossiers(true)
    },
    data() {
        return {
            isEmpty,
            primaryExternalURL: '',
            primary: this.INTERNAL || 'INTERNAL',
            secondary: this.INTERNAL || 'INTERNAL',
            step: 1,
            reportingGroups: [],
            details: [],
            optionsOrganisation:[
                {
                    name: 'Organisation > Overview',
                    id: 'Option1'
                }
            ],
            isFetchingCollections: false,
            isLoadMore: true,
            isFetchingDossiers: false,
            isLoadMoreDossiers: true,
            urlPopoverPrimary: false,
            urlPopoverBackup: false,
            collectionList: [],
            dossierList: [],
            isConfirm: false,
            isFinal: false,
            isProgress: false,
            markedItems: [],
            checkedData: [],
            selectedReporting: '',
            bulkUpdateData: {
                primary_url: {},
                secondary_url: {},
                reporting_group: {},
                is_archived: this.NO || 'NO'
            },
            progress: 0,
            isPrimaryExternalUrlVerified: false,
            isBackupExternalUrlVerified: false,
        }
    },
    methods: {
        /*
        * test domain
        */
        async testDomain (isBackup) {
            try {
                loader(this, true)
                // body
                let body = {
                    url: isBackup ? this.bulkUpdateData.secondary_url.external_url : this.bulkUpdateData.primary_url.external_url 
                }
                // api call
                let response = await isUrlReachable(body)

                if (isBackup) this.isBackupExternalUrlVerified = response.is_reachable
                else this.isPrimaryExternalUrlVerified = response.is_reachable
            } catch (error) {
                console.warn(error)
            }
            finally {
                loader(this, false)
            }
        },
        disabledTestButtonPrimary () {
            if ((this.primary !== this.EXTERNAL || this.bulkUpdateData.primary_url.external_url === '' || !urlValidation(this.bulkUpdateData.primary_url.external_url))) return true
            return false
        },
        /**
         * disable test button
         * @returns is-disabled true/false
         */
        disabledTestButtonBackup () {
            if ((this.secondary !== this.EXTERNAL || this.bulkUpdateData.secondary_url.external_url === '' || !urlValidation(this.bulkUpdateData.secondary_url.external_url))) return true
            return false
        },
        getReportingValue(id) {
            this.selectedReporting = id
            this.bulkUpdateData.reporting_group = this.reportingGroups.filter(item => item._id == id)
        },
        buttonAction (type) {
            switch (type) {
                case 'back':
                    this.step = 1
                    this.isConfirm = false
                    break
                case 'cancel':
                    this.$emit('close')
                    break
                case 'next':    
                    if (!isEmpty(this.markedItems)) {
                        this.checkedData = cloneDeep(this.markedItems)
                        this.step = 2
                        this.isConfirm = true
                    }
                    break
                case 'done':
                    this.$emit('refreshPage')
                    this.$emit('close')
                    break    
            }
        },
        /**
         * to fetch reporting groups
        */
        fetchreportingGroups () {
            if (!this.details._id) return
            // body for api
            let body = {
                organisation: this.details._id
            }
            // api call
            getReportingGroups(body)
            .then(response => {
                this.reportingGroups = response.result || []
            }).catch(error => {
                console.error(error)
            })
        },
        setInternalValue (value, type, isBackup) {
            let object = {}

            switch (type) {
                case constants.LIST.COLLECTION:
                    object = {
                        ...value,
                        type,
                        label: `Organisation > Collections > ${value.name || ''}`
                    }
                break
                case constants.LIST.DOSSIER:
                    object = {
                        ...value,
                        type,
                        label: `Organisation > Dossiers > ${value.name || ''}`
                    }
                break
                default:
                    object = {
                        ...value,
                        type_id: this.details._id,
                        type: constants.ORGANISATIONS.ORGANISATION,
                        label: `Organisation > Overview`
                    }
                break
            }

            if (isBackup) {
                this.bulkUpdateData.secondary_url = object
                this.urlPopoverBackup = false
            }
            else {
                this.urlPopoverPrimary = false
                this.bulkUpdateData.primary_url = object
            }
        },
        fetchCollections (isLoadMore) {
            if (!this.details._id) return
            this.isFetchingCollections = true
            // paarams for api
            let params = {
                skip: this.skip,
                limit: this.limit
            }
            // body for api
            let body = {
                entity_type: 'ORGANISATION',
                entity_id: this.details['_id']
            }
            // api call
            getMetaCollectionList(body, params)
            .then(response => {
                // if loading more than concat the list
                if (isLoadMore) this.collectionList = this.collectionList.concat(response.items || [])
                // initialise the list
                else this.collectionList = response.items || []
                // increase the skip
                this.skip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMore = false
                }
                // to make fetching false
                this.isFetchingCollections = false
            })
            .catch(() => {
                this.isLoadMore = true
                this.isFetchingCollections = false
                this.skip = 0
            })
        },
        async fetchDossiers (isLoadMore) {
            if (!this.details._id) return
            try {
                this.isFetchingDossiers = true
                // params for api
                let params = {
                    skip: this.dossierSkip,
                    limit: this.limit
                }
                // body for api
                let body = {
                    entity_type: 'ORGANISATION',
                    entity_id: this.details['_id']
                }
                // api call
                let response = await getMetaDossierList(body, params)
                // if loading more than concat the list
                if (isLoadMore) this.dossierList = this.dossierList.concat(response.items || [])
                // initialise the list
                else {
                    this.dossierList = response.items || []
                    // this.selectedCollection = (response.items && response.items[0]) || {}
                }
                // increase the skip
                this.dossierSkip += this.limit
                if (response.item_count < this.limit) {
                    this.isLoadMoreDossiers = false
                }
            } catch (error) {
                this.isLoadMoreDossiers = false
            }
            // to make fetching false
            this.isFetchingDossiers = false
        },
        /**
         * infinite loading handler collection
         */
        handleCollectionInfiniteLoading () {
            if (!this.isFetchingCollections && this.isLoadMore) this.fetchCollections(true)
        },

        /**
         * infinite loading handler dossier
         */
        handleDossierInfiniteLoading () {
            if (!this.isFetchingDossiers && this.isLoadMoreDossiers) this.fetchDossiers(true)
        },
        changeValues(type) {
            if (!this.markedItems.includes(type)) {
               this.markedItems.push(type)
            } else {
                const index = this.markedItems.indexOf(type)
                if (index > -1) this.markedItems.splice(index, 1)
            }
        },
        changeCheckedValues (type) {
            if (!this.checkedData.includes(type)) {
                this.checkedData.push(type)
             } else {
                 const index = this.checkedData.indexOf(type)
                 if (index > -1) this.checkedData.splice(index, 1)
             }
        },
        confirmButton() {
            this.isProgress = true 
            this.progress = 15  
            let body = this.getBody()
            if (isEmpty(this.checkedData) || isEmpty(body)) {
                this.isProgress = false
                message(this, constants.messageType.ERROR, "No fields added for updation")
                return
            }
            let entity_ids = uniq(this.markedTableItems)
            body.entity_ids = entity_ids 
            shortServiceBulkUpload(body).then(() => {  
                this.progress= 100  
                this.step = 3
                this.isFinal = true
            }).catch(error=>{
                console.warn('error', error)
                this.isProgress = false
            })
        },
        getBody() {
            let body = {
                primary_url: {},
                backup_url: {}
            }
            let data = cloneDeep(this.checkedData)
            // If the internal option is chosen, add the values corresponding to it
            if (data.includes('primaryURL') && this.primary === this.INTERNAL && !isEmpty(this.bulkUpdateData.primary_url)) {
                body.primary_url.type = constants.ORGANISATIONS.ORGANISATION
                body.primary_url.type_id = this.bulkUpdateData.primary_url._id || this.details._id
                if (this.bulkUpdateData.primary_url.type === constants.LIST.COLLECTION || this.bulkUpdateData.primary_url.type === constants.LIST.DOSSIER) {
                    body.primary_url.sub_type = this.bulkUpdateData.primary_url.type
                    body.primary_url.sub_type_id = this.bulkUpdateData.primary_url._id
                }
                body.primary_url.redirection_type = this.INTERNAL
                delete body.primary_url.external_url
            } else if (data.includes('primaryURL') && this.primary ==='EXTERNAL' && !isEmpty(this.bulkUpdateData.primary_url) && this.bulkUpdateData.primary_url.external_url !== ''){
                body.primary_url.type = constants.ORGANISATIONS.ORGANISATION
                body.primary_url.type_id = this.details._id
                body.primary_url.external_url = this.bulkUpdateData.primary_url.external_url
                body.primary_url.redirection_type = 'EXTERNAL'
            } else {
                delete body.primary_url
            }

            if(data.includes('secondaryURL') && this.secondary ==='INTERNAL' && !isEmpty(this.bulkUpdateData.secondary_url)) {
                body.backup_url.type = constants.ORGANISATIONS.ORGANISATION
                body.backup_url.type_id = this.details._id 
                if (this.bulkUpdateData.secondary_url.type === constants.LIST.COLLECTION || this.bulkUpdateData.secondary_url.type === constants.LIST.DOSSIER) {
                    body.backup_url.sub_type = this.bulkUpdateData.secondary_url.type
                    body.backup_url.sub_type_id = this.bulkUpdateData.secondary_url.sub_type_id
                }
                body.backup_url.redirection_type = 'INTERNAL'
                delete body.backup_url.external_url
            } else if (data.includes('secondaryURL') && this.secondary ==='EXTERNAL' && !isEmpty(this.bulkUpdateData.secondary_url) && this.bulkUpdateData.secondary_url.external_url){
                body.backup_url.type = constants.ORGANISATIONS.ORGANISATION
                body.backup_url.type_id = this.details._id
                body.backup_url.external_url = this.bulkUpdateData.secondary_url && this.bulkUpdateData.secondary_url.external_url
                body.backup_url.redirection_type = 'EXTERNAL'
            } else {
                delete body.backup_url
            }

            if (data.includes('reportingGroups') && this.selectedReporting) {
                body.reporting_group = this.bulkUpdateData.reporting_group && this.bulkUpdateData.reporting_group[0] && this.bulkUpdateData.reporting_group[0]._id || ''
            }

            if (data.includes('archive') && this.bulkUpdateData.is_archived == 'NO') {
                body.is_archived = false 
            } else if (data.includes('archive') && this.bulkUpdateData.is_archived == 'YES') {
                body.is_archived = true 
                body.is_active = false
            } else {
                delete body.is_archived
            }
            return body
        }
    }
}